import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logo from '../Assets/logo.png';
import {name, year} from "../Constant";
import Footer from "../Components/footer";

class Index extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      message: '',
    }
    }
    
    render(){
    return (
        <div className="App">
      <div className="body-wrapper" id="body-wrapper">

      <div className="form-first-child"> </div>
      
        <div className="form-wrapper">
      <div className="form-wrap">
        <div className="logo-wrap">
          <div className="logo-inner-wrap">
          <img className="logo" src={logo} alt=""/>
          </div>
          </div>
      <div className="form-inner-wrap"><br/>
       <div className="h1s">Welcome to {name} </div>
       <br/>
       <div className="form-group-lg">    
         <NavLink to="/login">
           <button className="btn btn-blue btn-link">LOGIN ACCOUNT</button>
           </NavLink>
         </div> 
         <div className="form-group-lg">
         <NavLink to="/register">
       <button className="btn btn-pink btn-link">CREATE ACCOUNT</button>
       </NavLink>
       </div> 
       <br/>
         </div>
        </div>
      </div>
      </div>

      <Footer/>
    </div>
    );
  }
}

export default Index;